import { isDbCollection } from "../../common/collectionType";
import { getRealResponseSchema } from "../../common/schemaUtil";
// db code message data 实体 list 方法特殊处理Array
// http fixedResponseSchema
export function getMethodReturnValue(instance, method) {
  var _instance$collection, _method$meta$cgi, _method$meta;
  if (!((_instance$collection = instance.collection) !== null && _instance$collection !== void 0 && _instance$collection.collectionData)) {
    return null;
  }
  const {
    type,
    cgiInfo
  } = instance.collection.collectionData;
  const cgi = (_method$meta$cgi = (_method$meta = method.meta) === null || _method$meta === void 0 ? void 0 : _method$meta.cgi) !== null && _method$meta$cgi !== void 0 ? _method$meta$cgi : '';
  if (!cgi) {
    return null;
  }
  if (isDbCollection(type)) {
    return getDBReturnValue(instance, method);
  }
  const info = cgiInfo[cgi];
  if (!info) {
    return null;
  }
  return getRealResponseSchema(info);
}
function getDBReturnValue(instance, method) {
  var _meta$cgi;
  const {
    meta
  } = method;
  const cgi = (_meta$cgi = meta === null || meta === void 0 ? void 0 : meta.cgi) !== null && _meta$cgi !== void 0 ? _meta$cgi : '';
  if (!cgis.includes(cgi)) {
    return null;
  }
  if (dbMap[cgi]) {
    return dbMap[cgi];
  }
  const entity = instance.getEntitySchema() || {
    type: 'object'
  };
  const isList = cgi === 'list';
  if (isList && (meta === null || meta === void 0 ? void 0 : meta.tpl) === 'list.listCount') {
    const d = {
      type: 'object',
      fields: [{
        id: 'listResult',
        ...makeDBResponseBodySchema(entity, true)
      }, {
        ...countBody,
        id: 'countResult'
      }]
    };
    return d;
  }
  return makeDBResponseBodySchema(entity, isList);
}
function makeDBResponseBodySchema(entity, isArray) {
  const data = isArray ? {
    type: 'array',
    items: entity
  } : {
    type: 'object',
    ...entity
  };
  return withCodeMessage(data);
}
function withCodeMessage(data) {
  return {
    type: 'object',
    fields: [{
      id: 'code',
      description: '返回码,0为成功，其他为失败',
      type: 'number'
    }, {
      id: 'message',
      description: '返回码!=0时，返回错误信息',
      type: 'string',
      required: false
    }, {
      ...data,
      id: 'data'
    }]
  };
}
;
const countBody = withCodeMessage({
  id: 'data',
  type: 'object',
  fields: [{
    id: 'total',
    description: '总数',
    type: 'number'
  }]
});
const deleteBody = withCodeMessage({
  id: 'data',
  type: 'boolean'
});
const dbMap = {
  count: countBody,
  delete: deleteBody
};
const cgis = ['list', 'count', 'delete', 'create', 'update', 'get'];
//# sourceMappingURL=getMethodReturnValue.js.map
